import React from "react";
import styles from "./NavbarSupplierLealtad.module.css";
import logo2 from "../../Lealtad/assets/logo/logo2.png";
import { Link } from "react-router-dom";

const NavbarSupplierLealtad = () => {
  return (
    <nav className={styles.navbarlealtad}>
      <div className={styles.logolealtad}>
        <Link to="/portal-comercializadores-lealtad/inicio">
          <img src={logo2} alt="logo" />
        </Link>
      </div>
    </nav>
  );
};

export default NavbarSupplierLealtad;
